import { Link } from "react-router-dom";
import * as Icons from "heroicons-react";
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import ReportSideBar from "../../Common/SideBar/ReportSideBar";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";
import SelectUser from "../../Common/CustomSelect/SelectUser";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import { useUserWiseSalesQuery } from "../../../services/reportsApi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const UserWiseSalesReport = () => {
  const auth = signInUser();

  const [warehouse, setWarehouse] = useState("allWh");
  const [userId, setUserId] = useState();

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId } = auth;
  const lang = useSelector((state) => state.languageReducer);
  const {
    data: salesData,
    isLoading,
    isError,
    error,
  } = useUserWiseSalesQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
    userId,
  });

  console.log("User Wise Sales Report Data:", salesData);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");

  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);
  // console.log("Customer Wise Sales Report Data:", salesData);

  // Export CSV
  const handleExportCSV = () => {
    if (!salesData || salesData.length === 0) {
      alert("No data available for export.");
      return;
    }

    const start = new Date(startDate).toLocaleString();
    const end = new Date(endDate).toLocaleString();
    // const end = salesData[salesData.length - 1]?.createdAt;
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportTitle = "User Wise Sales Report";

    const headerInfo = [
      `,Store: ${storeName},,,,,Warehouse: ${warehouseName}`,
      `,Report: ${reportTitle},,,,,Date Range: ${start} to ${end}`,
      `,Generated On: ${generatedOn},,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];

    const csvTableHeader = [
      "S/N",
      "Invoice No",
      "Date",
      "User Name",
      "Warehouse",
      "Quantity Sold",
      "Gross Profit",
      "Net Sales",
      "Discount",
      "Total Received",
      "Change Amount",
    ].join(",");

    let totalQty = 0;
  let totalGP = 0;
  let totalNet = 0;
  let totalDiscount = 0;
  let totalReceived = 0;
  let totalChange = 0;

  const csvRows = salesData.map((row, index) => {
    const qty = Number(row?.quantitySold || 0);
    const gp = Number(row?.grossProfit || 0);
    const net = Number(row?.totalSale || 0);
    const discount = Number(row?.discount || 0);
    const received = Number(row?.totalReceived || 0);
    const change = Number(row?.changeAmount || 0);

    totalQty += qty;
    totalGP += gp;
    totalNet += net;
    totalDiscount += discount;
    totalReceived += received;
    totalChange += change;

    return [
      index + 1,
      row?.invoiceNo || "",
      row?.createdAt || "",
      row?.userName?.trim() || "",
      row?.warehouseName || "",
      qty,
      gp,
      net,
      discount,
      received,
      change,
    ].join(",");
  });
  const summaryLabelRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "** TOTAL SUMMARY **",
  ].join(",");

  const summaryHeaderRow = [
    "",
    "",
    "",
    "",
    "",
    "Total Qty",
    "Gross Profit",
    "Net Sales",
    "Discount",
    "Received",
    "Change",
  ].join(",");

  const summaryDataRow = [
    "",
    "",
    "",
    "",
    "",
    totalQty,
    totalGP,
    totalNet,
    totalDiscount,
    totalReceived,
    totalChange,
  ].join(",");

  const csvContent = [
    ...headerInfo,
    csvTableHeader,
    ...csvRows,
    "",
    "",
    summaryLabelRow,
    summaryHeaderRow,
    summaryDataRow,
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "UserWiseSalesReport.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  };

  // export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");

    if (salesData?.length === 0) {
      alert("No sales data found.");
      return;
    }

    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "User Wise Sales Report";

    // Title
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });

    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });

    // Header info - Justify between
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39);
    // doc.text(`Report: ${reportName}`, 140, 28, { align: "center" });
    doc.text(`Generated At: ${reportGeneratedAt}`, 280, 28, { align: "right" });
    doc.text(`Generated By: ${auth?.name}`, 280, 33, { align: "right" });

    // Table header
    const headers = [
      [
        "S/N",
        "Invoice No",
        "Date",
        "User Name",
        "Quantity Sold",
        "Gross Profit",
        "Net Sales",
        "Discount",
        "Received",
        "Change",
      ],
    ];

    const data = salesData?.map((item, index) => [
      index + 1,
      item?.invoiceNo,
      item?.createdAt,
      item?.userName || "N/A",
      item?.quantitySold,
      parseFloat(item.grossProfit).toFixed(2),
      parseFloat(item.totalSale).toFixed(2),
      parseFloat(item.discount).toFixed(2),
      parseFloat(item.totalReceived).toFixed(2),
      parseFloat(item.changeAmount).toFixed(2),
    ]);

    autoTable(doc, {
      head: headers,
      body: data,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 9,
        halign: "center",
      },
      headStyles: {
        fillColor: [242, 101, 45], // tomato background
        textColor: [255, 255, 255], // white text
        fontStyle: "bold",
      },
    });

    // === Summary Box ===
    const finalY = doc.lastAutoTable.finalY + 10;
    const lineHeight = 7;
    const boxHeight = 7 * lineHeight + 10;
    const boxWidth = 100;

    const pageWidth = doc.internal.pageSize.getWidth();
    const boxX = pageWidth - boxWidth - 15;
    const boxY = finalY;

    doc.rect(boxX, boxY, boxWidth, boxHeight);

    let y = boxY + 10;
    const labelX = boxX + 5;
    const valueX = boxX + boxWidth - 5;
    doc.setFontSize(9);

    const quantitySold = sumField(salesData, "quantitySold");
    const totalGrossProfit = sumField(salesData, "grossProfit");
    const totalNetSales = sumField(salesData, "totalSale");
    const totalDiscount = sumField(salesData, "discount");
    const totalReceived = sumField(salesData, "totalReceived");
    const totalChange = sumField(salesData, "changeAmount");

    const netSalesNum = parseFloat(totalNetSales) || 0;
    const gpPercent =
      netSalesNum > 0
        ? ((parseFloat(totalGrossProfit || 0) / netSalesNum) * 100).toFixed(2)
        : "0.00";

    doc.text("Total Qty:", labelX, y);
    doc.text(`${quantitySold}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Gross Profit :", labelX, y);
    doc.text(`${totalGrossProfit}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Net Sales :", labelX, y);
    doc.text(`${totalNetSales}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Discount :", labelX, y);
    doc.text(`${totalDiscount}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Received :", labelX, y);
    doc.text(`${totalReceived}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Change :", labelX, y);
    doc.text(`${totalChange}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Gross Profit % :", labelX, y);
    doc.text(`${gpPercent}%`, valueX, y, { align: "right" });

    // Save the PDF
    doc.save("UserWiseSalesReport.pdf");
  };

  // Utility to sum values from objects
  const sumField = (data, field) =>
    data
      .reduce((acc, item) => acc + (parseFloat(item[field]) || 0), 0)
      .toFixed(2);

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> User Wise Sales Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className="d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
          <SelectUser aamarId={aamarId} onUserSelect={setUserId} />
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserWiseSalesReport;
